module.exports = __webpack_public_path__ + "static/media/policy_settings_approvals_workflow_manage.16c5da34.svg";